(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('forestService', forestService);

    forestService.$inject = ['$http', 'modelTransformer', 'messaging', 'events', 'StudentHour'];

    function forestService($http, modelTransformer, messaging, events, StudentHour) {
        var baseUrl = '/api/jccenter/';
        var service = {
            init: init
        };
        messaging.subscribe(events.message._GET_FOREST_SERVICE_PROJECT_LIST_, getForestServiceProjects);
        messaging.subscribe(events.message._GET_CENTER_HOURS_LIST_, getCenterHours);
        messaging.subscribe(events.message._GET_FOREST_LIST_, getForestList);
        messaging.subscribe(events.message._DELETE_PROJECT_FS_, deleteProjectFS);
        messaging.subscribe(events.message._GET_FOREST_PROJECT_, getForstProject);
        messaging.subscribe(events.message._SAVE_FOREST_PROJECT_, saveForestProject);

        return service;
        function init() {
        }
        function getForestServiceProjects(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'GetForestServiceProjects/' + id)
                .then(getForestServiceProjectsSuccessHandler, getForestServiceProjectsErrorHandler);

        }
        function getForestList() {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'GetForestList/')
                         .then(getForestListSuccessHandler, getForestListErrorHandler);

        }
        function getCenterHours(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'GetCenterHours/' + id)
                .then(getStudentHoursSuccessHandler, getStudentHoursErrorHandler);
        }



        function getForstProject(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'GetForestProject/' + id)
                .then(getForstProjectSuccessHandler, getForstProjectErrorHandler);
        }

        function getForstProjectSuccessHandler(results) {
            messaging.publish(events.message._GET_FOREST_PROJECT_COMPLETE_, [results.data]);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }

        function getForstProjectErrorHandler(results) {
            messaging.publish(events.message._GET_FOREST_PROJECT_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Forest Service Project', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }

        function saveForestProject(src) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'SaveForestProject/', src)
                .then(saveForestProjectSuccessHandler, saveForestProjectErrorHandler);
        }

        function saveForestProjectSuccessHandler(results) {
            messaging.publish(events.message._SAVE_FOREST_PROJECT_COMPLETE_, [results.data]);
           messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            messaging.publish(events.message._SAVE_SUCCESS_);
            doFileUploads(results.data.StudentHourProjectId, results.data.Creator);
        }

        function saveForestProjectErrorHandler(results) {
            messaging.publish(events.message._SAVE_FOREST_PROJECT_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Forest Service Project', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }


        function getForestServiceProjectsSuccessHandler(results) {
            if (results.data && results.data.length) {
                var projects = [];
                projects = results.data;
                messaging.publish(events.message._GET_FOREST_SERVICE_PROJECT_LIST_COMPLETE_, [projects]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getForestServiceProjectsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getForestListSuccessHandler(results) {
            if (results.data && results.data.length) {
                var forests = [];
                forests = results.data;
                messaging.publish(events.message._GET_FOREST_LIST_COMPLETE_, [forests]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getForestListErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentHoursSuccessHandler(results) {
            if (results.data && results.data.length) {
                var result = [];
                var students = [];
                angular.forEach(results.data, function (d) {
                    var dr = modelTransformer.transform(d, StudentHour);
                    result.push(dr);
                    students.push(dr);
                });
                students = result;
                messaging.publish(events.message._GET_CENTER_HOURS_LIST_COMPLETE_, [students]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentHoursErrorHandler(_results) {
            messaging.publish(events.message._GET_CENTER_HOURS_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Center Student Hour List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }
        function getForestListErrorHandler(_results) {
            messaging.publish(events.message._GET_FOREST_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Forest List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }
        function getForestServiceProjectsErrorHandler(_results) {
            messaging.publish(events.message._GET_FOREST_SERVICE_PROJECT_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Forest Service Projects List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);

        }



        //delete forest service
        function deleteProjectFS(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'DeleteStudentHourProject/' + id)
                .then(deleteProjectSuccessHandlerFS, deleteProjectErrorHandlerFS);
        }

        function deleteProjectSuccessHandlerFS(results) {
            if (results) {
                messaging.publish(events.message._DELETE_PROJECT_FS_COMPLETE_, [results]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteProjectErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function deleteProjectErrorHandlerFS(results) {
            messaging.publish(events.message._DELETE_PROJECT_FS_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete Project from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }

        //------------------------------------------------------

        function doFileUploads(ProjectId, LastUpdatedBy) {
            if (document.getElementById("fileUploadDocs").value != "") {
                var file = document.getElementById("fileUploadDocs").files[0];
                var fileName = document.getElementById("fileUploadDocs").files[0].name;
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    data.append("file", file);
                    //fileName = btoa(fileName);

                    $.ajax({
                        type: "POST",
                        url: baseUrl + "UploadFile/" + ProjectId + "/" + LastUpdatedBy + "/" + "abc",
                        contentType: false,
                        processData: false,
                        data: data,
                        success: function (result) {
                            console.info(result);
                        },
                        error: function (xhr, status, p3, p4) {
                            var err = "Error " + " " + status + " " + p3 + " " + p4;
                            if (xhr.responseText && xhr.responseText[0] == "{")
                                err = JSON.parse(xhr.responseText).Message;
                            console.error(err);
                        }
                    });
                }
                document.getElementById("fileUploadDocs").value = "";
                document.getElementById('btnSaveDoc').disabled = true;
            }
        }

        //--------------------------------------------------------
    }
})();
